(function ($) {

    function activateTab(selectedType) {

        var activeClass = "programs-of-study-filter-bar-tab-active";

        //hide the filter and results
        $('[data-pos-data]').hide();

        //remove all active classes
        $('[data-pos-title]').removeClass(activeClass);

        //add the active class to the clicked element
        $('[data-pos-title][data-pos-type="' + selectedType + '"]').addClass(activeClass);

        //add the active class to the filter bar variant
        //add the active class to the search results variant
        $('[data-pos-data][data-pos-type="' + selectedType + '"]').show();

        //note - need to track 3 different pages for pagination, similar to DH
    }

    function applyFilters(parent) {
        //get the filter elements
        var filters = $(parent).find('[data-pos-filter]');
        var search = $(parent).find('[data-pos-search]');

        var school = $(parent).find('[name="prog-filter-school"]').val();
        var degree = $(parent).find('[name="prog-filter-degree"]').val();
        var type = $(parent).find('[name="prog-filter-type"]').val();
        var location = $(parent).find('[name="prog-filter-location"]').val();

        //get the results element
        var resultsElement = $('[data-pos-data][data-pos-type="' + $(parent).attr('data-pos-type') + '"]');

        $(resultsElement).find('.prog-result').each(function () {

            var hide = true;
            //if there is a filter 
            if (typeof school !== 'undefined') {
                //and its not "All"
                if (school.toLowerCase() != 'all') {
                    //and it doesn't contain the selected
                    if ($(this).attr('data-school') != school) {
                        console.log("hidindg because " + $(this).attr('data-school') + "!=" + school);
                        $(this).addClass("prog-result-hidden");
                        return;
                    }
                }
            }

            //if there is a filter 
            if (typeof degree !== 'undefined') {
                //and its not "All"
                if (degree.toLowerCase() != 'all') {
                    //and it doesn't contain the selected
                    if ($(this).attr('data-degrees') != degree) {
                        console.log("hidindg because " + $(this).attr('data-degrees') + "!=" + degree);
                        $(this).addClass("prog-result-hidden");
                        return;
                    }
                }
            }

            //if there is a filter 
            if (typeof type !== 'undefined') {
                //and its not "All"
                if (type.toLowerCase() != 'all') {
                    //and it doesn't contain the selected
                    if ($(this).attr('data-program-types') != type) {
                        console.log("hidindg" + $(this).attr('data-count') + " because " + $(this).attr('data-program-types') + "!=" + type);
                        $(this).addClass("prog-result-hidden");
                        return;
                    }
                }
            }

            //if there is a filter 
            if (typeof location !== 'undefined') {
                //and its not "All"
                if (location.toLowerCase() != 'all') {
                    //and it doesn't contain the selected
                    if ($(this).attr('data-locations') != degree) {
                        console.log("hidindg because " + $(this).attr('data-locations') + "!=" + location);
                        $(this).addClass("prog-result-hidden");
                        return;
                    }
                }
            }

            $(this).removeClass("prog-result-hidden");
        });

        //reset page
        //TODO

        //update totals
        var total = $(resultsElement).find('.prog-result').not('.prog-result-hidden').length;
        $(parent).find('[data-pos-total]').text(total);
    }

    function serializeFormWithExclusions(form) {
        return $(form).find(':input').not('[data-form-exclude]').serialize();
    }

    function changeQueryString(queryString) {
        var newUrl = window.location.href.split(/[?#]/)[0] + "?" + queryString;
        window.history.pushState({ path: newUrl }, '', newUrl);
    }

    $.fn.hasAttr = function (name) {
        return this.attr(name) !== undefined;
    };

    function resetFormInput(element) {
        var attr = $(element).attr('data-input-default-value');

        if (typeof attr !== 'undefined' && attr !== false) {
            $(element).val(attr);

            //refresh any selectric UI to reflect the selection
            if ($(element).is('select') && $(element).hasAttr('data-selectric')) {
                $(element).selectric('refresh');
            }
        }
    }

    function resetFormInputs(form) {
        var inputs = form.find(':input');
        $(inputs).each(function () {
            resetFormInput(this);
        });
    }

    function copyFormValues(sourceForm) {
        //copy the inputs to all other forms
        var submittedFormInputs = sourceForm.find(':input');
        //find the shared identifer among the forms
        var identifier = $(sourceForm).attr('data-ajax-update');

        var forms = $('form[data-ajax-update="' + identifier + '"]').not(sourceForm);

        $(forms).each(function () {
            var form = $(this);

            $(submittedFormInputs).each(function () {
                //find the input in the current looped form by name
                var formInput = form.find('[name=' + $(this).attr('name') + ']');

                if (formInput.length > 0) {
                    //replace its value
                    formInput.val($(this).val());

                    //refresh any selectric UI to reflect the selection
                    if ($(this).is('select') && $(formInput).hasAttr('data-selectric')) {
                        $(formInput).selectric('refresh');
                    }
                }
            });
        });
    }

    $(document).ready(function () {

        //because we can't determine when a load is ajax or the initial page load, we use javascript to hide the other result tabs
        $('.programs-of-study').each(function () {
            $(this).find('.prog-results:not(:first)').hide();
        });

        // custom select boxes
        $('.programs-of-study [data-selectric]').selectric(
            {
                responsive: true,
                arrowButtonMarkup: "<span class='button'></span>",
                disableOnMobile: false
            }
        );

        $('.programs-of-study-filter-bar-tab').on('click', function () {
            var selectedType = $(this).attr('data-pos-type');
            activateTab(selectedType);
        });

        $(document).on('click', '[data-form-clear-inputs]', function () {

            var form = $($(this).attr('data-form-clear-inputs'));

            if (!form.length) {
                form = $(this).closest('form');
            }

            resetFormInputs(form);
            form.submit();
        });

        $(document).on('change keyup paste', '[data-pos-search]', $.throttle(100, false, function () {
            var val = $(this).val();
            var closestGroup = $(this).closest('.input-group');
            var clearButton = $(closestGroup).find('button[data-form-clear-input]');
            if (val) {
                clearButton.show();
            }
            else {
                clearButton.hide();
            }
        }));

        $(document).on('click', '[data-form-clear-input]', function () {
            var form = $(this).closest('form');
            var inputSelector = $(this).attr('data-form-clear-input');
            var input = form.find(inputSelector);
            resetFormInput(input);
        });

        //poorly implemented modal library only allows for a single close button due to ID identification, so we have to trigger that button's effect for other UI elements
        $(document).on('click', '[data-modal-close]', function () {
            var modal = $(this).closest('.modal');
            var closeButton = modal.find('#js-modal-close');
            closeButton.trigger('click');
        });

        /*
        $('[data-pos-filter]').on('change', function () {
            var parent = $(this).closest('[data-pos-type]');
            applyFilters(parent);
            $(this).closest('form').submit();
        });
        */

        /*        $('[data-pos-search]').on('keypress', function (e) {
                    if (e.which == 13) {
                        var form = $(this).closest('form');
                        form.submit();
                    }
                });*/

        $(document).on('click', 'a.pagination-link', function (e) {
            e.preventDefault();
            var pageNum = $(this).attr('data-pagenum');
            var parent = $(this).closest('.prog-results');
            var ID = parent.attr('id');
            var form = $('[data-ajax-update="#' + ID + '"]').filter(":visible");
            var pageElement = form.find('[name=page]');
            pageElement.val(pageNum);

            //serialize all inputs
            var serializedInput = serializeFormWithExclusions(form);
            //update query string
            //changeQueryString(serializedInput);

            smoothScrollToElement(parent);

            form.submit();
        });

        // on submit event doesn't work due to the modal library, which seems to take an initial copy of the markup on load rather than a dynamic one
        window.addEventListener('show.modal', function (e) {
            /*            console.log("showed modal");
                        console.log(e.detail.relatedTarget);
                        console.log(e.detail.modal);*/

            var sourceForm = $(e.detail.relatedTarget).closest('form');
            copyFormValues(sourceForm);

        }, false);

        window.addEventListener('closing.modal', function (e) {
            //console.log("closing modal");

            var sourceForm = $(e.detail.relatedTarget).closest('form');
            copyFormValues(sourceForm);
        }, false);

    });
})($JQ);




